module.exports = __webpack_public_path__ + "static/media/workshop.7982d1fc.png";